import type { Locale } from "antd/es/locale-provider";
import enUS from "antd/locale/en_US";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import merge from "lodash/merge";
import { DeepPartial } from "setup/deepPartial";

const useAntdLocale = (): Locale => {
  const intl = useIntl();

  return useMemo<Locale>(
    () =>
      merge<Locale, DeepPartial<Locale>>(enUS, {
        DatePicker: {
          lang: {
            ok: intl.formatMessage({
              defaultMessage: "Submit",
            }),
          },
        },
      }),
    [intl]
  );
};

export default useAntdLocale;
